import React from 'react';
import styled from 'styled-components';
import LockIcon from '../resource/figma-images/footer-lock-image.svg';
import PowerByImage from '../resource/figma-images/footer-power-by-image.svg';

const FooterWrapper = styled.div`
  padding: 35px 0 0;
  text-align: center;
  color: #747F94;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterLink = styled.a`
  font-weight: 600;
  color: #747F94;
`

const LockIconimage = styled.img`
  width: 18px;
  height: 24px;
`

const PowerByImageWrapper = styled.img`
  width: 182px;
  height: 37px;
`

const FooterText = styled.span`
  color: #747F94;
  font-size: 15px;
  font-weight: 500;
  padding: 0 3px 0 7px;
`

export const Footer = () => {
  return <FooterWrapper>
    <LockIconimage src={LockIcon}/>
    {/*<FooterText>Guaranteed <FooterLink href='https://oligo.com.au/legal-info/' target='_blank'>safe and secure</FooterLink> payments</FooterText>*/}
    <FooterText>Guaranteed safe and secure payments</FooterText>
    <a href="https://oligo.com.au" target="_blank" rel="noopener noreferrer">
      <PowerByImageWrapper src={PowerByImage}/>
    </a>
  </FooterWrapper>;
};
